import React from 'react';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import clsx from 'clsx';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Typography from '@material-ui/core/Typography';
import useTheme from '@material-ui/core/styles/useTheme';
import { Checkbox, Filter, Pagination } from '@shared/components';
import { areEqual, findLastIndex } from '@utils';

import {
  useStyles,
  StyledTableCell,
  StyledTableRow,
  StyledTableHeaderRow,
} from './style';

import SortActiveIcon from '@assets/icons/sort-blue.svg';
import SortIcon from '@assets/icons/sort-grey.svg';
import NoRecords from '@assets/icons/no-records.svg';
import NoRecordsDark from '@assets/icons/no-records-dark.svg';

import DropdownArrowIcon from '@assets/icons/down-outline-arrow-grey.svg';

import CardLoader from './card-loader';
import GridLoader from './grid-loader';
import { FormControlLabel } from '@material-ui/core';

let isShiftHeld = false;
const noop = () => {};

// TODO: Implement collapsible rows. Plan is to calculate and hold children
// for each row inside element of rows array.
const defaultState = {
  rows: [],
  //   columns: [],
  areAllSelected: false,
  sortBy: null,
  sortOrder: '',
};

const GridComponent = ({
  childIdentifier = 'defaultRowChildIdentifier',
  cardView = false,
  columns = [],
  data = [],
  disabled = false,
  emptyStateLabel = null,
  filters = [],
  isFiltering = false,
  isFormVisible = false,
  isLoading = false,
  hasLoader = false,
  hasSelection = true,
  hiddenCount = null,
  hasPagination = true,
  keepSelection = false,
  pageSize = 5,
  pageNumber = 1,
  onFilterClose = noop,
  onPageNumberChange = noop,
  onPageSizeChange = noop,
  onReady = noop,
  onSearch = noop,
  onSelectAll = noop,
  onSelectionChange = noop,
  onSort = noop,
  renderCard = noop,
  rowCount = null,
  search = '',
  total = 5,
  sortBy = null,
  sortOrder = '',
  uniqueBy = 'id',
  showRowDivider = false,
  classes: passedClasses = {},
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const [state, setState] = React.useState({
    ...defaultState,
    sortBy,
    sortOrder,
  });
  const columnRefs = [];

  React.useEffect(() => {
    document.addEventListener(
      'keydown',
      event => {
        if (event.which == 16 || event.shiftKey) {
          isShiftHeld = true;
        }
      },
      true
    );

    document.addEventListener(
      'keyup',
      event => {
        if (event.which == 16 || event.shiftKey) {
          isShiftHeld = false;
        }
      },
      true
    );
    return () => {
      document.onkeydown = null;
      document.onkeyup = null;
    };
  }, []);

  //   React.useEffect(() => {
  //     if (JSON.stringify(columns) !== JSON.stringify(state.columns)) {
  //       setState(prevState => ({ ...prevState, columns }));
  //     }

  //     // //  if (!areEqual(columns, state.columns)) {
  //     // setState(prevState => ({ ...prevState, columns }));
  //     // //  }
  //   }, [columns, state.columns]);

  React.useEffect(() => {
    if (sortBy !== state.sortBy || sortOrder !== state.sortOrder) {
      setState(prevState => ({
        ...prevState,
        sortBy,
        sortOrder,
      }));
    }
  }, [sortBy, sortOrder]);

  React.useEffect(() => {
    // if (!areEqual(data, state.rows)) {
    // setState(prevState => {
    //   // const updatedRows = keepSelection
    //   //   ? data.map(dataRow => {
    //   //       const stateRow = prevState.rows.find(
    //   //         stateRow => stateRow[uniqueBy] === dataRow[uniqueBy]
    //   //       );
    //   //       return stateRow
    //   //         ? { ...dataRow, isSelected: stateRow.isSelected }
    //   //         : { ...dataRow, isSelected: false };
    //   //     })
    //   //   : data;
    //   // return {
    //   //   ...prevState,
    //   //   rows: updatedRows,
    //   // };
    //   if (keepSelection) {
    //     const selectedRows = prevState.rows
    //       .filter(row => row.isSelected)
    //       .map(selectedRow => selectedRow[uniqueBy]);
    //     const updatedRows = (data || []).slice();
    //     // selectedRows.forEach(selectedRow => {
    //     //   const rowIndex = updatedRows.findIndex(
    //     //     row => row[uniqueBy] === selectedRow[uniqueBy]
    //     //   );
    //     //   if (rowIndex !== -1) {
    //     //     updatedRows[rowIndex].isSelected = true;
    //     //   }
    //     // });
    //     for (let index = 0; index < updatedRows.length; index += 1) {
    //       if (selectedRows.indexOf(updatedRows[index][uniqueBy]) !== -1) {
    //         updatedRows[index].isSelected = true;
    //       }
    //     }

    //     return {
    //       ...prevState,
    //       rows: updatedRows,
    //     };
    //   } else {
    //     return {
    //       ...prevState,
    //       rows: data,
    //     };
    //   }
    // });
    // }

    let updatedRows = (data || []).slice();
    if (keepSelection) {
      const selectedRows = state.rows
        .filter(row => row.isSelected)
        .map(selectedRow => selectedRow[uniqueBy]);
      for (let index = 0; index < updatedRows.length; index += 1) {
        updatedRows[index] = { ...updatedRows[index] };
        const selectedRowIndex = selectedRows.indexOf(
          updatedRows[index][uniqueBy]
        );

        if (selectedRowIndex !== -1) {
          updatedRows[index].isSelected = true;
          delete selectedRows[selectedRowIndex];
          if (selectedRows.length === 0) {
            index = updatedRows.length;
          }
        }
      }
    }

    setState(prevState => ({
      ...prevState,
      rows: updatedRows,
    }));
    // eslint-disable-next-line
  }, [data]);

  const handleExpansionClick = (rowId = '') => {
    const rowIndexes = rowId.split(':');
    const updatedRows = state.rows.slice();
    let elementRow = updatedRows[rowIndexes[0]];
    for (let iterator = 1; iterator < rowIndexes.length; iterator++) {
      elementRow = elementRow[childIdentifier][rowIndexes[iterator]];
    }

    elementRow.isChildRowVisible = !elementRow.isChildRowVisible;
    setState(prevState => {
      return {
        ...prevState,
        rows: updatedRows.slice(),
      };
    });
  };

  const handleSortClick = (column, columnIndex) => {
    if (isFormVisible) {
      return;
    }
    let newOrder = null;
    if (!state.sortOrder) {
      newOrder = 'ASC';
    }
    if (state.sortOrder?.toLowerCase() === 'asc') {
      newOrder = 'DESC';
    }

    if (state.sortOrder?.toLowerCase() === 'desc') {
      newOrder = null;
    }

    if (columnIndex != state.sortBy) {
      newOrder = 'ASC';
    }

    onSort(column.field ? column.field : column.fieldName, newOrder);

    setState(prevState => ({
      ...prevState,
      sortOrder: newOrder,
      sortBy: columnIndex,
      setSelectedRows: [],
      visibleSelection: false,
    }));
  };

  const findRow = React.useCallback(
    (rows, rowIndexes) => {
      let row = rows[rowIndexes[0]];
      for (let iterator = 1; iterator < rowIndexes.length; iterator += 1) {
        row = row[childIdentifier][rowIndexes[iterator]];
      }

      return row;
    },
    [childIdentifier]
  );

  //   const getSelectedRows = React.useCallback(
  const getSelectedRows = rows => {
    const selectedRows = [];
    if (!rows) {
      rows = state.rows;
    }

    //   rows.forEach(row => {
    //     if (row.isSelected) {
    //       selectedRows.push(row);
    //     }

    //     if (row[childIdentifier] && row[childIdentifier].length > 0) {
    //       selectedRows.push(...getSelectedRows(row[childIdentifier]));
    //     }
    //   });

    for (let index = 0; index < rows.length; index += 1) {
      const row = rows[index];
      if (row.isSelected) {
        selectedRows.push(row);
      }

      if (row[childIdentifier] && row[childIdentifier].length > 0) {
        console.log('FIRED INSIDE');
        selectedRows.push(...getSelectedRows(row[childIdentifier]));
      }
    }

    return selectedRows;
  };
  // [state.rows]
  //   );

  const getNewSelection = (
    updatedRows,
    rowId,
    isChecked,
    shouldCheckChild = true
  ) => {
    const rowIndexes = rowId.split(':');

    const row = findRow(updatedRows, rowIndexes);

    if (row.isDisabled) {
      return;
    }

    if (isShiftHeld && shouldCheckChild) {
      let rows = updatedRows;
      for (let iterator = 1; iterator < rowIndexes.length; iterator += 1) {
        rows = rows[rowIndexes[iterator - 1]][childIdentifier];
      }
      const rowIndex = rowIndexes[rowIndexes.length - 1];
      const lastSelectedIndex = findLastIndex(
        rows.slice(0, rowIndex),
        row => row && row.isSelected
      );
      if (isChecked) {
        if (
          lastSelectedIndex !== null &&
          lastSelectedIndex !== undefined &&
          lastSelectedIndex !== -1
        ) {
          if (rowIndex > lastSelectedIndex) {
            for (
              let rowIterator = lastSelectedIndex + 1;
              rowIterator < rowIndex;
              rowIterator++
            ) {
              rows[rowIterator].isSelected = isChecked;
            }
          }
        }
      } else {
        let rowIterator = +rowIndex + 1;
        while (rows[rowIterator] && rows[rowIterator].isSelected) {
          rows[rowIterator].isSelected = isChecked;
          rowIterator++;
        }
      }
    }

    row.isSelected = isChecked;
    if (childIdentifier !== 'defaultRowChildIdentifier') {
      if (shouldCheckChild) {
        for (
          let iterator = rowIndexes.length - 2;
          iterator > -1;
          iterator -= 1
        ) {
          const elementRow = findRow(
            updatedRows,
            rowIndexes.slice(0, iterator + 1)
          );
          if (elementRow && elementRow[childIdentifier]) {
            const children = elementRow[childIdentifier];
            elementRow.isSelected =
              children.filter(child => !child.isSelected).length === 0;
          }
        }
      }
      for (let iterator = rowIndexes.length - 1; iterator > -1; iterator -= 1) {
        const elementRow = findRow(
          updatedRows,
          rowIndexes.slice(0, iterator + 1)
        );
        if (elementRow && elementRow[childIdentifier]) {
          const children = elementRow[childIdentifier];
          if (iterator === rowIndexes.length - 1) {
            if (elementRow[childIdentifier]) {
              elementRow[childIdentifier].forEach((child, childIndex) => {
                getNewSelection(
                  updatedRows,
                  `${rowId}:${childIndex}`,
                  elementRow.isSelected,
                  false
                );
              });
            }
          }
          //  else {
          //     elementRow.isSelected = children.filter(child => !child.isSelected).length === 0;
          // }
        }
      }
    }

    return updatedRows;
  };

  const handleSelection = (rowId, isChecked, shouldUpdateState = true) => {
    console.log('Fired', rowId);
    const updatedRows = getNewSelection(state.rows.slice(), rowId, isChecked);
    if (shouldUpdateState) {
      setState(prevState => ({
        ...prevState,
        rows: updatedRows,
      }));
      console.log('PRE GET SELECTED');
      onSelectionChange(getSelectedRows(updatedRows));
    } else {
      return updatedRows;
    }
  };

  const handleSelectVisible = event => {
    if (state.rows.find(row => row.isDisabled)) {
      return;
    }

    const isSelected = event.currentTarget.checked;
    const updatedRows = [];
    state.rows.map((row, rowIndex) => {
      const selectedRows = handleSelection(rowIndex + '', isSelected, false);
      updatedRows.push(selectedRows[rowIndex]);
    });

    setState(prevState => ({
      ...prevState,
      rows: updatedRows,
    }));

    onSelectionChange(getSelectedRows(updatedRows));
  };

  onReady({
    getSelectedRows: () => getSelectedRows(),
    resetSelection: () =>
      setState(prevState => {
        const updatedRows = prevState.rows.map(row => ({
          ...row,
          isSelected: false,
        }));
        return {
          ...prevState,
          rows: updatedRows,
        };
      }),
    resetAllSelection: () => {
      setState(prevState => ({ ...prevState, areAllSelected: false }));
    },
  });

  const selectedRows = state.rows.filter(row => row.isSelected);

  const getRows = (currentRows, id = '') => {
    return (
      <>
        {currentRows.map((row, rowIndex) => {
          // return React.useMemo(() => {
          if (row.renderer) {
            return row.renderer(row);
          }

          const rowId = id.length > 0 ? `${id}:${rowIndex}` : `${rowIndex}`;
          return (
            <>
              <StyledTableRow
                className={clsx(
                  columns[0].getRowClassName && columns[0].getRowClassName(row),
                  {
                    disabled: row.isDisabled,
                    [classes.rowDivider]:
                      row.isChildRowVisible || showRowDivider,
                  }
                )}
                key={`grid-row-${id}-${row[uniqueBy]}`}
                aria-checked={state.areAllSelected || row.isSelected}
                selected={state.areAllSelected || row.isSelected}
              >
                {(hasSelection ||
                  (row[childIdentifier] &&
                    row[childIdentifier].length > 0)) && (
                  <StyledTableCell
                    padding='checkbox'
                    className={clsx(classes.checkboxCell, {
                      'pr-0 ws-no-wrap':
                        row[childIdentifier] && row[childIdentifier].length > 0,
                    })}
                  >
                    <span className='d-flex f-align-center'>
                      {row[childIdentifier] && row[childIdentifier].length > 0 && (
                        <span
                          onClick={event => {
                            event.preventDefault();
                            event.stopPropagation();
                            handleExpansionClick(rowId);
                          }}
                        >
                          <img
                            src={DropdownArrowIcon}
                            className={clsx(classes.expandIcon, 'mt-1', {
                              [classes.expandRotate]: row.isChildRowVisible,
                            })}
                          />
                        </span>
                      )}
                      {hasSelection && id === '' && (
                        <Checkbox
                          disableRipple
                          checked={state.areAllSelected || !!row.isSelected}
                          disabled={row.isDisabled}
                          onChange={event =>
                            handleSelection(rowId, event.currentTarget.checked)
                          }
                        />
                      )}
                    </span>
                  </StyledTableCell>
                )}
                {columns.map((column, columnIndex) => {
                  if (column.isHidden) {
                    return null;
                  }

                  let content = column.field ? (
                    <Typography
                      className='d-inline-block w-100'
                      variant='body2'
                      component='span'
                      noWrap={column.hasEllipses}
                    >
                      {row[column.field]}
                    </Typography>
                  ) : null;
                  if (column.render) {
                    content = column.render(row, rowIndex);
                  }

                  if (column.getDataTooltip) {
                    content = (
                      <Tooltip
                        title={column.getDataTooltip(column, row)}
                        placement={column.dataTooltipPlacement || 'top-start'}
                      >
                        <span>{content}</span>
                      </Tooltip>
                    );
                  }

                  return (
                    <StyledTableCell
                      key={`grid-row-${row[uniqueBy]}-${columnIndex}`}
                      className={clsx(column.className, {
                        'd-flex f-align-center':
                          hasSelection && id !== '' && columnIndex === 0,
                      })}
                    >
                      <>
                        {hasSelection && id !== '' && columnIndex === 0 && (
                          <Checkbox
                            disableRipple
                            checked={state.areAllSelected || !!row.isSelected}
                            disabled={row.isDisabled}
                            onChange={event =>
                              handleSelection(
                                rowId,
                                event.currentTarget.checked
                              )
                            }
                          />
                        )}
                        {content}
                      </>
                    </StyledTableCell>
                  );
                })}
              </StyledTableRow>
              {row[childIdentifier] &&
                row[childIdentifier].length > 0 &&
                row.isChildRowVisible && (
                  <>{getRows(row[childIdentifier], rowId)}</>
                )}
            </>
          );
          // }, [row]);
        })}
      </>
    );
  };

  return (
    <>
      {hasLoader && isLoading ? (
        <>
          {cardView ? (
            <CardLoader pageSize={pageSize} />
          ) : (
            <GridLoader pageSize={pageSize + 1} columns={columns.length} />
          )}
        </>
      ) : cardView ? (
        <div
          className={clsx(
            'd-flex f-wrap',
            classes.cardViewWrapper,
            passedClasses.cardViewWrapper
          )}
        >
          {state.rows.map(row => {
            return (
              <div key={`grid-card-element-${row[uniqueBy]}`}>
                {renderCard({
                  row,
                  onSelectionChange: handleSelection,
                })}
              </div>
            );
          })}
        </div>
      ) : (
        <TableContainer className={passedClasses.container}>
          <Table size='small' stickyHeader className={passedClasses.table}>
            <TableHead className={passedClasses.tableHead}>
              <StyledTableHeaderRow
                className={clsx(passedClasses.headerRow, {
                  disabled: disabled,
                  [classes.rowDivider]: showRowDivider,
                })}
              >
                {hasSelection && (
                  <StyledTableCell
                    padding='checkbox'
                    className={clsx(classes.checkboxCell, 'align-center')}
                  >
                    <Checkbox
                      disableRipple
                      color='primary'
                      checked={
                        state.rows.length > 0 &&
                        (state.areAllSelected ||
                          state.rows.filter(row => row.isSelected).length ===
                            state.rows.length)
                      }
                      disabled={disabled}
                      onChange={handleSelectVisible}
                    />
                  </StyledTableCell>
                )}
                {columns.map((column, columnIndex) => {
                  if (column.isHidden) {
                    return;
                  }
                  columnRefs[columnIndex] = React.createRef();
                  const label = <span>{column.label}</span>;
                  let content = (
                    <Typography
                      className='p-relative w-100 d-flex f-align-center semibold-font f-justify-between'
                      variant='caption'
                    >
                      {column.canSort ? (
                        <TableSortLabel
                          active={state.sortBy === columnIndex}
                          key={columnIndex}
                          direction={
                            state.sortBy === columnIndex
                              ? (state.sortOrder || '').toLowerCase()
                              : 'asc'
                          }
                          onClick={() => handleSortClick(column, columnIndex)}
                        >
                          {label}
                        </TableSortLabel>
                      ) : (
                        label
                      )}
                      {!column.noResize && (
                        <div
                          className={clsx(
                            'd-flex f-justify-between f-align-center',
                            classes.resizeIconWrapper
                          )}
                          data-role='resize'
                          onMouseDown={event => {
                            if (
                              columnRefs[columnIndex] &&
                              columnRefs[columnIndex].current
                            ) {
                              const element = columnRefs[columnIndex].current;
                              document.onmouseup = () => {
                                document.onmousemove = null;
                              };

                              document.onmousemove = (() => {
                                const initialCursorX = event.pageX;
                                const initialWidth = element.offsetWidth;
                                return event => {
                                  if (initialCursorX) {
                                    const diffX = event.pageX - initialCursorX;
                                    element.style.minWidth = `${initialWidth +
                                      diffX}px`;
                                  }
                                };
                              })();
                            }
                          }}
                          onMouseUp={() => {
                            console.log('Fired local');
                            document.onmousemove = null;
                          }}
                        >
                          <div className={classes.resizeIcon} />
                        </div>
                      )}
                    </Typography>
                  );

                  if (column.headerTooltip) {
                    content = (
                      <Tooltip
                        title={column.headerTooltip || null}
                        placement={column.tooltipPlacement || 'top-start'}
                      >
                        {content}
                      </Tooltip>
                    );
                  }
                  return (
                    <StyledTableCell
                      className={column.headerClassName}
                      key={`grid-header-${
                        typeof column.label === 'string'
                          ? column.label
                          : columnIndex
                      }`}
                      component='th'
                      ref={columnRefs[columnIndex]}
                      scope='row'
                    >
                      {content}
                    </StyledTableCell>
                  );
                })}
              </StyledTableHeaderRow>
            </TableHead>
            <TableBody className={passedClasses.tableBody}>
              <>
                {!isLoading && data.length === 0 && (
                  <StyledTableRow>
                    <StyledTableCell />
                    <StyledTableCell colSpan={columns.length}>
                      <div
                        className={clsx('d-flex f-justify-center', {
                          'flex-column': emptyStateLabel,
                        })}
                      >
                        <img
                          src={
                            theme && theme.palette.type === 'dark'
                              ? NoRecordsDark
                              : NoRecords
                          }
                        />
                        {emptyStateLabel}
                      </div>
                    </StyledTableCell>
                  </StyledTableRow>
                )}
                {getRows(state.rows)}
              </>
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {!isLoading && data.length > 0 && hasPagination && (
        <Pagination
          disabled={disabled}
          hiddenCount={hiddenCount}
          elements={[
            <div className='ml-4 d-flex f-align-center'>
              {cardView && (
                <FormControlLabel
                  className={classes.paginationItems}
                  control={
                    <Checkbox
                      disableRipple
                      color='primary'
                      checked={
                        state.areAllSelected ||
                        (state.rows.length > 0 &&
                          state.rows.filter(row => row.isSelected).length ===
                            state.rows.length)
                      }
                      onChange={handleSelectVisible}
                      size='small'
                    />
                  }
                  label={
                    <Typography variant='body2'>Select Visible</Typography>
                  }
                />
              )}
              {/* <div key={'select-all'}>
                <Button
                  className={clsx(
                    'ml-5 mr-5 color-text-primary',
                    classes.paginationItems,
                    {
                      'bg-primary color-white': state.areAllSelected,
                    }
                  )}
                  disableRipple
                  onClick={event => {
                    onSelectAll(!state.areAllSelected);
                    setState(prevState => ({
                      ...prevState,
                      areAllSelected: !prevState.areAllSelected,
                    }));
                  }}
                  variant='text'
                  color='default'
                >
                  Select All
                </Button>
                {(state.areAllSelected || selectedRows.length > 0) && (
                  <Typography
                    className='color-primary d-inline-flex'
                    variant='body2'
                  >
                    {state.areAllSelected
                      ? 'All Entries '
                      : selectedRows.length > 1
                      ? `${selectedRows.length} Entries `
                      : '1 Entry '}
                    Selected
                  </Typography>
                )}
              </div> */}
            </div>,
          ]}
          onPageNumberChange={onPageNumberChange}
          onPageSizeChange={onPageSizeChange}
          pageNumber={pageNumber}
          pageSize={pageSize}
          rowCount={
            rowCount
              ? rowCount
              : isFormVisible
              ? state.rows.length - 1
              : state.rows.length
          }
          total={total}
        />
      )}
    </>
  );
};

GridComponent.whyDidYouRender = true;

// export default React.memo(GridComponent, (prevProps, nextProps) => {
//   //   return (
//   //     areEqual(prevProps.data, nextProps.data) &&
//   //     areEqual(prevProps.columns, nextProps.columns) &&
//   //     prevProps.isLoading === nextProps.isLoading &&
//   //     prevProps.keepSelection === nextProps.keepSelection &&
//   //     prevProps.uniqueBy === nextProps.uniqueBy &&
//   //     prevProps.isFiltering === nextProps.isFiltering &&
//   //     prevProps.isFormVisible === nextProps.isFormVisible
//   //   );
//   console.log('PREvProps', prevProps);
//   console.log('NextProps', nextProps);
//   return JSON.stringify(prevProps) === JSON.stringify(nextProps);
// });

export default GridComponent;
